export const GET_PARAMS = {
  CATEGORY: "category",
  CURRENCY: "currency",
  PROVIDERS: "name",
  POPUP: "popup",
  NOTIFICATION_ID: "notificationId",
  SUBPOPUP: "subpopup",
  STATUS: "status",
  METHOD: "method",
  MODE: "mode",
  CLICK_ID: "clid",
  LANG: "lang",
  SEARCH_RESULT: "search_result",
  BONUS_ID: "bonusId",
  UTM_MEDIUM: "utm_medium",
  UTM_SOURCE: "utm_source",
  UTM_CAMPAIGN: "utm_campaign",
  PAGE: "page",
  TOURNAMENT: "tournament",
  LIVE_CASINO: "live-casino",
};

export const GET_POPUP_TYPES = {
  popup: {
    signIn: "sign-in",
    signUp: "sign-up",
    recovery: "recovery",
    recoveryComplete: "recovery-complete",
    deposit: "deposit",
    withdraw: "withdraw",
    winWheel: "win-wheel",
    regWheel: "reg-wheel",
    aviatorReg: "aviatore-registration",
    changePassword: "change-password",
    changeEmail: "change-email",
    depositResult: "deposit-result",
    withdrawResult: "withdraw-result",
    failDeposit: "deposit-failed",
    bonus: "bonus",
    cancelBonus: "cancel-bonus",
    changeLanguage: "change-language",
    provider: "provider",
    sortProvider: "sort-provider",
    gameSearch: "game-search",
    logoutConfirm: "logout-confirm",
    password: "password",
    sideMenu: "side-menu",
    countries: "countries",
    invite: "invite",
    inviteNull: "invite-null",
    sortTransaction: "sort-transaction",
    share: "share",
    coinStrikeReg: "coin-strike-registration",
    promocodeApply: "promocode-apply",
    phoneCountries: "phone-countries",

    welcomeBonusNotification: "notification-welcome",
    firstDepositNotification: "notification-first-deposit",
    transferToMainNotification: "notification-transfer-to-main",

    wageringCounterNotification: "notification-wagering-counter",

    bonusAddedNotification: "notification-bonus-added",
    independenceDayCounterNotification: "notification-independence-counter",
    independenceDayFinalNotification: "notification-independence-final",
    independenceDayNotification: "notification-independence-day",
    moneyBonusNotification: "notification-bonus-money",
    cashoutConfirmNotification: "notification-cashout-confirm",

    utilizationBalance: "notification-utilization-balance",
    firstFailedDeposit: "notification-first-failed-deposit",
    secondFailedDeposit: "notification-second-failed-deposit",
    thirdFailedDeposit: "notification-third-failed-deposit",

    freespinAvailableNotification: "notification-freespin-available",
    freespinAssignedNotification: "notification-freespin-assigned",
    freespinAccuredNotification: "notification-freespin-accured",
    passwordRegistration: "password-registration-confirm",

    // Pl
    rewardsLevel: "reward-level",
    rewardsLevelCompleted: "reward-level-completed",
    rewardsRank: "reward-rank",
    rewardsRankCompleted: "reward-rank-completed",
    boosterInfo: "booster-info",
    boosterActivate: "booster-activate",
    loyaltyOnboarding: "loyalty-onboarding",
    rollbackInfo: "rollback-info",
    cashbackAssign: "cashback-assign",
    rankUp: "rank-up",
    levelRankUp: "level-rank-up",
    boosterAvailable: "booster-available",
    daysWithoutProgress: "days-without-progress",
    manyDaysWithoutProgress: "many-days-without-progress",
    levelDanger: "level-danger",
    rollback: "rollback",
  },
  page: {
    profile: "profile",
    password: "password",
    invite: "invite",
    inviteNull: "invite-null",
  },
  subpopup: {
    selectBank: "bank-select",
  },
};
